import React, { FunctionComponent, PropsWithChildren } from 'react';
import { Divider, Header, Segment } from 'semantic-ui-react';
import { Breadcrumb } from './Breadcrumb';

type Props = {
    header: string;
    subtitle?: string;
    basic?: boolean;
    breadcrumb?: boolean;
};

const Template: FunctionComponent<PropsWithChildren<Props>> = ({
    breadcrumb,
    children,
    header,
    subtitle,
    basic = false,
}) => {
    return (
        <>
            <Segment style={{ display: breadcrumb ? '' : 'contents', padding: '20px' }}>
                <Header as='h2' style={{ padding: 0, margin: 0 }} content={header} subheader={subtitle} />
                {breadcrumb && (
                    <>
                        <Breadcrumb />
                        <Divider />
                    </>
                )}

                <Segment
                    basic={basic || breadcrumb}
                    style={{
                        padding: (basic && '0px') || (breadcrumb && '10px 0'),
                        border: (basic && 'none') || undefined,
                    }}
                >
                    {children}
                </Segment>
            </Segment>
        </>
    );
};

export default Template;
